import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {EnvironmentService} from "@iw-shop/core//services/environment.service";
import {Observable} from "rxjs";
import {
  ApiArticleRatingsDeleteRequest,
  ApiArticleRatingsDeleteResponse,
  ApiArticleRatingsGetRequest, ApiArticleRatingsGetResponse,
  ApiArticleRatingsSetRequest,
  ApiArticleRatingsSetResponse, ApiArticleRatingsUpdateRequest, ApiArticleRatingsUpdateResponse
} from "@api/article-ratings";

@Injectable({
  providedIn: 'root'
})
export class ArticleRatingService {

  constructor(private http: HttpClient, private environmentService: EnvironmentService) {
  }

  set(data: ApiArticleRatingsSetRequest['params']['data']): Observable<ApiArticleRatingsSetResponse> {
    const body: ApiArticleRatingsSetRequest = {
      id: 'setArticleRating#INVALID_PARAMS',
      command: 'articleRatings/set',
      params: {
        data
      }
    };
    return this.http.post<ApiArticleRatingsSetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
  }

  get(params: ApiArticleRatingsGetRequest['params']): Observable<ApiArticleRatingsGetResponse> {
    const body: ApiArticleRatingsGetRequest = {
      id: 'getArticleRatings',
      command: 'articleRatings/get',
      params: params
    };
    return this.http.post<ApiArticleRatingsGetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
  }

  update(data: ApiArticleRatingsUpdateRequest['params']['data']): Observable<ApiArticleRatingsUpdateResponse> {
    const body: ApiArticleRatingsUpdateRequest = {
      id: 'updateArticleRatings#INVALID_PARAMS',
      command: 'articleRatings/update',
      params: {
        data
      }
    };
    return this.http.post<ApiArticleRatingsUpdateResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
  }

  delete(id: string): Observable<ApiArticleRatingsDeleteResponse> {
    const body: ApiArticleRatingsDeleteRequest = {
      id: 'deleteArticleRatings',
      command: 'articleRatings/delete',
      params: {
        data: {
          id
        }
      }
    };
    return this.http.post<ApiArticleRatingsDeleteResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
  }
}
